
import dayjs from 'dayjs'
export default {
    props: {
        tenantId: {
            type: Number,
            default: 0
        },
        itemData: {
            type: Object,
            default: ()=>{}
        },
        fixImg: {
            type: String,
            default: ""
        },
        configurations: {
            type: Object,
            default: ()=>{}
        },
        getMallItemList: {
            type: Function,
        },
    },
    data() {
        return {
            panicItems: [],
            groupBuyingItems: []
        }
    },
    watch: {
        itemData: {
            handler() {
                this.init()
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        getComponentsName(styleId) {
            let names = ["FloatImg", "MultiImg", "mallItemPerson", "SwiperImg", "CategroyEnter", "TextLink", "FillEmpty", "splitLine", "rushGood", "groupGood", "serviceTemp", "goodsClass", "", "", "advancedGroup"]
            return names[styleId - 6]
        },
        async getData() {
            this.panicItems = []
            this.groupBuyingItems = []
            let {content} = await this.getMallItemList()
            content.forEach(item => {
                if(item.saleprop == 1){
                    this.panicItems.push(item)
                }
                if(item.allowgroupbuying){
                    this.groupBuyingItems.push(item)
                }
            })
        },
        //转换团购组件
        _convertGroupGood(data) {
            var groupGoodArr = []
            if (data && data.content && data.content.groupGoogNum && this.groupBuyingItems && this.groupBuyingItems.length > 0) {
            for (var i = 0; i < this.groupBuyingItems.length; i++) {
                var groupItem = this.groupBuyingItems[i];
                if (dayjs(groupItem.endTime).valueOf() > dayjs().valueOf()) {
                groupItem.showGroupNum = data.content.showGroupNum;
                groupGoodArr.push(groupItem);
                if (groupGoodArr.length == data.content.groupGoogNum) {
                    break;
                }
                }
            }
            }
            data.groupGoodArr = groupGoodArr
            return data
        },
        //转换抢购组件
        _convertRushGood(data) {
            var rushGoodArr = []
            if (data && data.content && data.content.rushGoogNum && this.panicItems && this.panicItems.length > 0) {
            for (var i = 0; i < this.panicItems.length; i++) {
                var rushItem = this.panicItems[i];
                if (dayjs(rushItem.endTime).valueOf() > dayjs().valueOf()) {
                    rushGoodArr.push(rushItem);
                    if (rushGoodArr.length == data.content.rushGoogNum) {
                        break;
                    }
                }
            }
            }
            data.rushGoodArr = rushGoodArr
            return data
        },
        // 转换分割线组件
        _convertSplitLine(data) {
            let {
            color,       // 分割线颜色
            lineStyle,   // 分割线线型
            margin,      // 分割线边距
            marginTb,    // 分割线上下边距
            marginStyle, // 分割线留边
            marginTbStyle // 分割线上下留边
            } = data.pattern
            let lineStr = 'solid'
            switch (lineStyle) {
            case 1:
                lineStr = 'solid'
                break;
            case 2:
                lineStr = 'dashed'
                break;
            case 3:
                lineStr = 'dotted'
                break;
            default:
                break;
            }
            let style = `border-top:1px ${lineStr} ${color}; width: calc(100% - 0px); margin: ${marginTb > 1 ? marginTbStyle : 0}px ${margin > 1 ? marginStyle : 0}px`
            data.viewStyle = style

            return data
        },
        // 转换空白填充组件数据
        _convertFillEmpty(data) {
            let { color, fillHeight } = data.pattern
            let style = `background-color: ${color}; height: ${fillHeight}px`
            data.viewStyle = style
            return data
        },
        // 转换商品模块数据结构
        async _convertGoodsGrid(ids) {
            let list    = []
            let {content} = await this.getMallItemList(ids)
            list = this.convertData(content)
            return list || []
        },
        convertData(list) {
            var self = this;
            list && list.length > 0 && list.forEach(datalist => {
                if (datalist.images) {
                    let images = datalist.images.split(",");
                    datalist.showImg = this.getPicture('mall', {
                        file: images[0],
                        type: "mall",
                        size: "s",
                        options: {
                            parentShopId: this.tenantId
                        }
                    });
                }
                if (datalist.tagImages) {
                    datalist.tagImages = this.getPicture('tagImages', {
                        file: datalist.tagImages
                    });
                }
                var thatday = dayjs(datalist.starttime);
                if(dayjs().endOf("day").isBefore(thatday)) {
                    datalist.startTi = thatday.format('M月D日');
                } else {
                    datalist.startTi = thatday.format('HH:mm:ss');
                }
                if (datalist.saleprop == 1) {
                    datalist.goodStatu = 1;
                    if (datalist.starttime > dayjs().valueOf()) {
                        datalist.goodStatu = 1;
                    } else if (datalist.amount === datalist.useamount && datalist.starttime <= dayjs().valueOf() && datalist.endtime > dayjs().valueOf()) {
                        datalist.goodStatu = 2;
                    } else if (datalist.starttime <= dayjs().valueOf() && datalist.endtime > dayjs().valueOf()) {
                        datalist.goodStatu = 3;
                    } else if (datalist.endtime <= dayjs().valueOf()) {
                        datalist.goodStatu = 4;
                    }
                }
                if(datalist.allowGroupBuying) {
                    datalist.isGroupBuying = true;
                    var groupBuyData = JSON.parse(datalist.groupbuyingdetail);
                    if(groupBuyData.length == 1) {
                        datalist.bestPrice = (groupBuyData[0].ownerPrice&&(groupBuyData[0].ownerPrice<groupBuyData[0].price))?groupBuyData[0].ownerPrice:groupBuyData[0].price;
                    } else {
                        datalist.bestPrice = (groupBuyData[1].ownerPrice&&(groupBuyData[1].ownerPrice<groupBuyData[1].price))?groupBuyData[1].ownerPrice:groupBuyData[1].price;
                    }
                }
            });
            // console.log('list', '=========', list);
            return list
        },
        getIds(array) {
            let temp = []
            array.map(item => {
                temp.push(item.id.toString())
            })
            return temp
        },
        // 转换文本链接数据结构
        _convertTextLink(data) {
            let { underLine, size, color, showIcon, lineHeight, textAlign } = data.pattern

            let textAlignStr = textAlign == 1 ? "left" : textAlign == 2 ? "center" : "right"
            let style = `${underLine ? 'text-decoration: underline' : ''}; color: ${color}; font-size: ${size}px;line-height:${lineHeight}px;text-align:${textAlignStr};`
            let iconStyle = `color: ${color}; font-size: ${(size - 6)}px`
            data.viewStyle = style
            data.iconStyle = iconStyle
            data.actionType = data.content.actionType
            data.showIcon = showIcon
            return data
        },
        // 转换分类入口、轮播图入口数据结构
        _convertSwiperImg(data) {
            data.cateList = data.cateList.filter(obj => {
            // obj.isOpen == true;
            var logos = JSON.parse(JSON.stringify(obj.logo));
            if (obj.isTempImg && logos.indexOf("malltemplatephoto") == -1) {
                obj.logo = this.getPicture('isTempImage', {
                    file: logos
                });
            }
            if (obj.isOpen) return obj
            })
            console.log(data.cateList);
            // 分类入口
            if (data.style == 10) {
            data.showNum = data.cateList.length > 5 && data.cateList.length ? 5 : data.cateList.length
            }
            return data
        },
        // 转换图片宫格或者混合图片数据结构
        _convertFloatImg(data) {
            let { imgList } = data.content
            data.content.imgList = imgList.filter((item, i) => i < imgList.length)
            // 混合图片
            if (data.style == 7) {
            console.log("混合图片配置数据======", data)
            let { layoutType, marginvalue, margin } = data.pattern
            if (layoutType == 1) {
                // 左二右一
                data.viewClass = 'ltro'
            } else {
                // 左一右二
                data.viewClass = 'lort'
            }
            let width = 364 - ((margin || 0) * 2)
            let style = `calc(50vw)`
            let styleH = `${width}px`

            let iW = (width - marginvalue) / 2
            let isOdd = (width - marginvalue) % 2
            data.content.imgList.forEach((item, i) => {
                // 左1右2
                if (layoutType == 0) {
                if (i == 0) {
                    item.style = `width: ${iW}px; height: ${styleH}`
                } else {
                    item.style = `width: ${isOdd ? iW + 1 : iW}px; height: ${isOdd ? iW + 1 : iW}px`
                }
                } else {
                if (i == 1) {
                    item.style = `width: ${iW}px; height: ${styleH}`
                } else {
                    item.style = `width: ${isOdd ? iW + 1 : iW}px; height: ${isOdd ? iW + 1 : iW}px`
                }
                }
                if (item.isTempImg) {
                item.imgSrc = this.getPicture('isTempImage', {
                    file: item.src,
                });
                } else {
                item.imgSrc = this.getPicture('multiImg', {
                    file: item.src,
                    suffix: 'iopcmd=thumbnail&type=6&width=1280&height=1280',
                    options: {
                    parentShopId: this.tenantId
                    }
                });
                }
            });
            // data.marginbottom = `margin-bottom: ${marginvalue * 2}px `
            } else {
            // 宫格图片
            console.log("图片宫格配置数据======", data)
            const { gridline, gridrow, marginvalue } = data.pattern
            if (!data.picSize) {
                data.picSize = [0, 0];
            }
            let len = gridline * gridrow            // 宫格数
            // // calc: 宽/高
            let iW = data.picSize[0]           // 图片宽
            let iH = data.picSize[1]           // 图片高
            let margin = (gridline - 1) * marginvalue || 0
            let itemW = (this.screenWidth - margin) / gridline            // 单宫格宽
            let calc = iW / itemW                    // 宽高比例
            let itemH = Math.ceil(iH / calc)     // 单宫格高
            let igW = iW > itemW ? itemW : iW
            let igH = iH > itemH ? itemH : iH

            // data.st = `height: ${(igH)}px`
            let gridH = gridrow * igH + (gridrow - 1) * marginvalue
            let sigleItem = `height: ${gridH}px;`
            data.girdStyle = `
                    grid-template-columns: repeat(${gridline}, 1fr);
                    grid-template-rows: repeat(${gridrow}, 1fr);
                    grid-gap: ${marginvalue}px;
                    display: grid;
                `

            data.imgSt = `width:${igW}px; height: ${igH}px`
            if (data.content.imgList.length > len) {
                data.content.imgList.length = len
            }
            data.content.imgList.forEach((item, j) => {
                if (item.isTempImg) {
                item.imgSrc = this.getPicture('isTempImage', {
                    file: item.src,
                });
                } else {
                item.imgSrc = this.getPicture('personImg', {
                    file: item.src,
                    suffix: `iopcmd=thumbnail&type=6&width=${len < 2 ? 1280 : 700}&height=${len < 2 ? 1280 : 700}`,
                    options: {
                    parentShopId: this.tenantId
                    }
                });
                }
            })
            data.gridWrapClassName = `grid-view__${len}`;
            }
            return data
        },
        _convertAdvancedGroup(data) {
            const { picSize, imgUrl, isTempImg } = data;
            const [width, height] = picSize;
            data.girdStyle = `width: ${width}px; height: ${height}px;`;
            const imgType = isTempImg ? 'isTempImage' : 'multiImg';
            data.imgSrc = this.getPicture(imgType, {
            file: imgUrl,
            options: {
                parentShopId: this.tenantId,
            }
            });
            return data;
        },
        _convertBrandDetail(data){
            if(data.content.img.src){
                const imgType = data.content.img.isTempImg ? 'isTempImage' : 'multiImg';
                data.content.img.url = this.getPicture(imgType, {
                    file: data.content.img.src,
                    options: {
                        parentShopId: this.tenantId,
                    }
                });
            }
            return data
        },
        getPicture(type, opt) {
            var url = this.fixImg;
            var timestamp = new Date().getTime() + '';
            timestamp = timestamp.substr(0, 9)
            switch (type) {
            case 'isTempImage':
                return url + 'malltemplatephoto/' + opt.file;
            case 'multiImg':
                return url + 'tenant/' + opt.options.parentShopId + '/' + opt.file;
            case 'personImg':
                return url + 'tenant/' + opt.options.parentShopId + '/' + opt.file + '?' + opt.suffix
            case 'mall':
                if(opt.file == "minipro/vipcard_bg.jpg" || opt.file == "minipro/coupon_bg.jpg"){
                return url + opt.file;
                }
                return url + this.getImageUrl(type, opt.options, opt.file, opt.size);
            case "tagImages":
                return `${url}mioss/productLabel/${opt.file}.png`
            default:
                break;
            }
        },
        getImageUrl(type, itemData, filename, suffix) {
            if (!filename) {
            throw "缺少文件名参数!";
            }
            var opt = {
                    "dir": "mall/%parentShopId%/",
                    "size": [1024, 1024],
                    "name": "uuid",
                    "variations": [{
                        "suffix": "l",
                        "resolution": "1024x1024"
                    }, {
                        "suffix": "m",
                        "resolution": "512x512"
                    }, {
                        "suffix": "s",
                        "resolution": "256x256"
                    }]
                };
            if (opt) {
            var ret = this.replaceHtml(opt.dir, itemData);
            if (!/^[^%]*$/.test(ret)) {
                //参数不足则报错
                throw "参数不足!"
            }
            return this.processType(ret + filename, suffix);
            } else {
            throw "错误的图片类型!";
            }
        },
        replaceHtml(html, obj) {
            for (var variable in obj) {
            if (obj[variable]) {
                html = html.replace("%" + variable + "%", obj[variable]);
            }
            }
            return html;
        },
        processType(filepath, type) {
            if (filepath && type) {
            var tempArr = filepath.split(".");
            if (tempArr.length >= 2) {
                tempArr[tempArr.length - 2] += ("_" + type);
                return tempArr.join(".");
            } else {
                return filepath + "_" + type;
            }
            } else {
            return filepath;
            }
        },
        getPrivilegePrice(data) {
            const configurations = this.configurations;
            const secondPrivilegePrice = data.secondPrivilegePrice || data.SECONDPRIVILEGEPRICE;
            const privilegePrice = data.privilegePrice || data.PRIVILEGEPRICE;
            if (typeof secondPrivilegePrice === 'number' && configurations && configurations.enableDistributionMode != '1') {
                return secondPrivilegePrice
            }
            return privilegePrice;
        },
        async _filter(data) {
            let item = JSON.parse(JSON.stringify(data));
            let gridGoods = [];
            let goodsClass = [];
            switch (item.style) {
                case 6:
                    item = this._convertFloatImg(item);
                break;
                case 7:
                    item = this._convertFloatImg(item)
                break
                case 8:
                    gridGoods.push(item);
                break;
                case 17:
                    goodsClass.push(item);
                break;
                case 9:
                case 10:
                    item = this._convertSwiperImg(item);
                break;
                case 11:
                    item = this._convertTextLink(item)
                break;
                case 12:
                    item = this._convertFillEmpty(item)
                break;
                case 13:
                    item = this._convertSplitLine(item)
                break;
                case 14:
                    await this.getData()
                    item = this._convertRushGood(item)
                break;
                case 15:
                    await this.getData()
                    item = this._convertGroupGood(item)
                break;
                case 16:
                // item = item
                break;
                case 20:
                    item = this._convertAdvancedGroup(item)
                break;
                case 24:
                case 27:
                    item = this._convertBrandDetail(item)
                break;
                default:
                    item = JSON.parse(JSON.stringify(item))
                break;
            }
            let goodsList = [],
                goodsClassList = [];
            if(gridGoods.length){
                let idsArr =[];
                for (let index = 0; index < gridGoods.length; index++) {
                    const data = gridGoods[index];
                    let {goodsList} = data.content
                    if(goodsList.length){
                        idsArr=idsArr.concat(this.getIds(goodsList))
                    }
                }
                //把所有需要商品一次性拉出来
                goodsList = await this._convertGoodsGrid(idsArr)
            }
            if(goodsClass.length){
                let idsArr =[];
                let categoryIdNameMap = {}
                for (let index = 0; index < goodsClass.length; index++) {
                    const data = goodsClass[index];
                    let {goodsList} = data.content
                    if(goodsList.length){
                        idsArr=idsArr.concat(this.getIds(goodsList))
                        goodsList.forEach(item => {
                            categoryIdNameMap[item.id] = item.category
                        })
                    }
                }
                //把所有需要商品一次性拉出来
                goodsClassList = await this._convertGoodsGrid(idsArr)
                goodsClassList = goodsClassList.map((item,index) => {
                    item.subcategoryName = categoryIdNameMap[item.id]
                    return item
                })
            }
            if(goodsList.length || goodsClassList.length){
                if(item.style==8){
                    let newItem = [];
                    if(goodsList&&goodsList.length){
                        let subGoodsList=item.content.goodsList;
                        let gids=this.getIds(subGoodsList)
                        for (let index = 0; index < goodsList.length; index++) {
                            const good = goodsList[index];
                            good.viewPrivilegePrice = this.getPrivilegePrice(good);
                            //对比，如果他有这个商品，给他
                            if(gids.indexOf(good.id+'')!=-1){
                                newItem.push(good)
                            }
                        }
                    }
                    item.goodsList=newItem;
                }
                if(item.style==17){
                    let newItem = [];
                    if(goodsClassList&&goodsClassList.length){
                        let subGoodsList=item.content.goodsList;
                        let gids=this.getIds(subGoodsList)
                        for (let index = 0; index < goodsClassList.length; index++) {
                            const good = goodsClassList[index];
                            good.viewPrivilegePrice = this.getPrivilegePrice(good);
                            //对比，如果他有这个商品，给他
                            if(gids.indexOf(good.id+'')!=-1){
                                newItem.push(good)
                            }
                        }
                    }
                    let map = {}
                    newItem.forEach(item => {
                        if(map[item.subcategoryName]){
                            map[item.subcategoryName].goodsList.push(item)
                        }else{
                            map[item.subcategoryName] = {
                            name: item.subcategoryName,
                            goodsList: [item]
                            }
                        }
                    })
                    item.goodsList=Object.values(map).map((item,index)=>{
                        if(index == 0){
                            item.hover = true
                        }else{
                            item.hover = false
                        }
                        item.id = index
                        return item
                    });
                }
            }
            return item
        }
    },
    mounted() {
        
    }
}